// extracted by mini-css-extract-plugin
export var closeButton = "_kq-1";
export var closeX = "_kq-3";
export var container = "_kq-0";
export var image = "_kq-2";